import { Box, CircularProgress } from "@mui/material";

/**
 * Component that displays a loading spinner while a clause checklist mutation is pending.
 */
export const ClauseChecklistMutationPending = () => {
    return (
        <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            flexGrow={1}
        >
            <CircularProgress size={48} thickness={5} />
        </Box>
    );
};
